import { render, staticRenderFns } from "./UserDetailsFormFields.vue?vue&type=template&id=1cd9cf64&scoped=true"
import script from "./UserDetailsFormFields.vue?vue&type=script&lang=js"
export * from "./UserDetailsFormFields.vue?vue&type=script&lang=js"
import style0 from "./UserDetailsFormFields.vue?vue&type=style&index=0&id=1cd9cf64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd9cf64",
  null
  
)

export default component.exports